export default "__VITE_ASSET__DFaSgOnn__"